export default "__VITE_ASSET__CWOlPqyz__"